import React from 'react'
import { CustomTable } from '../../../CustomTable/CustomTable'
import { getTenantInfoByKey } from '../../../../helpers/helpers'
import { t } from 'i18next'
import PermanenceSubTotalsDetailTableList from './PermanenceSubTotalsDetailTableList'

const PermanenceSubTotalsDetailTable = ({ subTotalsReport }) => {
    const headers = [
        { key: t('CODE') },
        { key: getTenantInfoByKey('building_name') },
        { key: t('NORMAL_HS_SHORT') },
        { key: t('50%_HS_SHORT') },
        { key: t('100%_HS_SHORT') },
        { key: t('TOTAL_HS') },
    ]

    return (
        <div>
            <CustomTable headers={headers}>
                {subTotalsReport.map((subTotalReport, idx) =>
                    <PermanenceSubTotalsDetailTableList
                        subTotalReport={subTotalReport}
                        key={idx}
                    />
                )}
            </CustomTable>
        </div>
    )
}

export default PermanenceSubTotalsDetailTable